<template>
  <form>
    <div class="row ml-1">
      <div class="col">
        <strong class="d-block">Servicio:</strong>
        <span>{{ serviceTypeTitle }}</span>
      </div>
      <div class="col">
        <ValidationProvider
          v-slot="{ errors }"
          name="Modalidad"
          rules="required"
        >
          <CustomDropDown
            v-model="selectedModality"
            required
            :options="modalityList"
            fieldkey="id"
            fieldname="name"
            label="Modalidad:"
            placeholder="Seleccione"
            class="block-spacing"
            :error="disabledAll ? '' : errors[0]"
            :custom-error-msg="
              disabledAll ? '' : 'Seleccione la modalidad del servicio.'
            "
            :disabled="disabledAll || modalityReadOnly"
            @input="$emit('on-change-modality', { ...selectedModality })"
          />
          <Error
            v-if="showModalityWarning"
            :isAlertMode="true"
            message="Esta selección está en modo lectura porque se ha seleccionado una alternativa que requiere servicios en el hogar. 
            Esto asegura que se proporcionen los servicios necesarios de manera adecuada."/>         
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="Tipo de enfoque"
          :rules="isApproachRequired ? 'required' : ''"
        >
          <CustomDropDown
            v-model="selectedApproach"
            :options="approachList"
            fieldkey="id"
            fieldname="name"
            :placeholder="disabledApproachType ? '' : 'Seleccione'"
            label="Tipo de enfoque:"
            class="block-spacing"
            :error="isApproachRequired || disabledAll ? errors[0] : ''"
            :custom-error-msg="
              isApproachRequired || disabledAll
                ? 'Seleccione el tipo de enfoque.'
                : ''
            "
            :disabled="disabledAll || disabledApproachType"
            @input="$emit('on-change-approach', { ...selectedApproach })"
          />
          <Error
            v-if="alternatePlacementIsSalonRegular"
            :isAlertMode="true"
            message="Esta selección está en modo lectura porque se ha seleccionado una alternativa que requiere servicios en Salón Regular con el tipo de enfoque mixto. Esto asegura que se proporcionen los servicios necesarios de manera adecuada."/>
        </ValidationProvider>
      </div>
      <div class="col">
        <ValidationProvider
          v-slot="{ errors }"
          name="Duración"
          rules="required"
        >
          <CustomDropDown
            v-model="selectedDuration"
            :options="durationList"
            fieldkey="id"
            fieldname="name"
            label="Duración:"
            placeholder="Seleccione"
            class="block-spacing"
            :error="errors[0]"
            custom-error-msg="Seleccione la duración del servicio."
            :disabled="disabledAll"
            @input="$emit('on-change-duration', { ...selectedDuration })"
          />
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="Frecuencia"
          rules="required"
        >
          <CustomDropDown
            v-model="selectedFrequency"
            :options="frequencyList"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            label="Frecuencia:"
            class="block-spacing"
            :error="errors[0]"
            custom-error-msg="Seleccione la frecuencia del servicio."
            :disabled="disabledAll"
            @input="$emit('on-change-frequency', { ...selectedFrequency })"
          />
        </ValidationProvider>
      </div>
    </div>
  </form>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { CustomDropDown } from '@/components/common';
import Error from "@/components/common/Error.vue";

export default {
  name: 'EducationService',
  data() {
    return {
      selectedModality: null,
      selectedApproach: null,
      selectedDuration: null,
      selectedFrequency: null,
      disabledApproachType: false,
    };
  },
  computed: {
    visualControlCode: () => 1,
    modalityReadOnly() {
      return this.modalityList.length === 1;
    },
  },
  props: {
    modalityList: {
      type: Array,
      default: () => [],
    },
    approachList: {
      type: Array,
      default: () => [],
    },
    durationList: {
      type: Array,
      default: () => [],
    },
    frequencyList: {
      type: Array,
      default: () => [],
    },
    serviceTypeTitle: {
      type: String,
      default: () => 'Educativo',
    },
    isApproachRequired: {
      type: Boolean,
      deafult: () => true,
    },
    disabledAll: {
      type: Boolean,
      default: () => false,
    },
    showModalityWarning: {
      type: Boolean,
      default: () => false,
    },
    alternatePlacementIsSalonRegular: {
      type: Boolean,
      default: () => false,
    }
  },
  watch: {
    modalityList(value) {
      if (value && this.modalityReadOnly) {
        this.selectedModality = { id: value[0].id, name: value[0].name };

        this.$emit('on-change-modality', { ...this.selectedModality });
      }     
    },
    approachList(value)
    {
      if (value && value.length == 1) {
        this.selectedApproach = { id: value[0].id, name: value[0].name };
        this.disabledApproachType = true;
      }     
    }
  },
  components: {
    ValidationProvider,
    CustomDropDown,
    Error,
  },
};
</script>

<style scoped src="@/assets/css/component/radio-button.css" />
<style scoped>
.block-spacing {
  margin-bottom: 30px;
}

.block-spacing >>> .invalid {
  position: absolute;
  font-size: 13px;
  margin-left: 5px;
}
</style>
